export default function combineFunctions<T>(...functions: ((...args: T[]) => void)[]): (...args: T[]) => void {
  return (...args) => {
    for (const callback of functions) {
      callback(...args);
    }
  };
}
